import React from 'react';
import './order-details.scss';
import { SVGS } from '../../assets';

interface PromotionChipsProps {
  promotions: string[];
}

export const PromotionChips: React.FC<PromotionChipsProps> = ({
  promotions,
}) => {
  const filteredPromos = promotions.filter(
    (name) => name !== 'Inline Discount'
  );

  return (
    <>
      {filteredPromos.slice(0, 2).map((promotionItem) => (
        <div key={promotionItem} className="order-details-promotions-view">
          <img src={SVGS.FreePromotionIcon} width={16} height={16} />
          <span className="order-details-promotions-text font-regular">
            {promotionItem}
          </span>
        </div>
      ))}
      {filteredPromos.length > 2 && (
        <span className="order-details-promotions-extra font-medium">
          {`+${filteredPromos.length - 2}`}
        </span>
      )}
    </>
  );
};
